import { xhr } from '../utils';
import { sortByWord } from '../utils';

const SET_SEARCH_RESULTS = 'hawaiian-dictionary/words/SET_SEARCH_RESULTS';

const SET_SELECTED_WORD = 'hawaiian-dictionary/words/SET_SELECTED_WORD';

const SET_WORDS_OF_THE_DAY = 'hawaiian-dictionary/words/SET_WORDS_OF_THE_DAY';

const CLEAR_SEARCH_RESULTS = 'hawaiian-dictionary/words/CLEAR_SEARCH_RESULTS';

const initialState = {
  searchResults: [],
  selectedWord: { word: null },
  wordsOfTheDay: [
    {
      word: '',
      definition: {
        def_src: '',
        ps: '',
        dtxt: '',
        botanical: '',
      },
    },
  ],
};

export default function reducer(words = initialState, action = {}) {
  switch (action.type) {
    case SET_SELECTED_WORD:
      return {
        ...words,
        selectedWord: action.selectedWord.data,
      };
    case SET_SEARCH_RESULTS:
      return {
        ...words,
        searchResults: action.searchResults,
      };
    case SET_WORDS_OF_THE_DAY:
      return {
        ...words,
        wordsOfTheDay: action.wordsOfTheDay.data,
      };
    case CLEAR_SEARCH_RESULTS:
      return {
        ...words,
        searchResults: [],
      };
    default:
      return words;
  }
}

export function getWordById(wordId) {
  return dispatch => {
    return xhr({ path: `/words/${wordId}` })
      .then(selectedWord => {
        dispatch({ type: SET_SELECTED_WORD, selectedWord });
        return selectedWord.data;
      })
      .catch(err => {
        throw err;
      });
  };
}

export function getWords(searchTerm) {
  return dispatch => {
    return xhr({ path: `/words?text=${searchTerm}` })
      .then(response => {
        if (!response) {
          dispatch({ type: SET_SEARCH_RESULTS, searchResults: null });
          return null;
        }
        const { searchResults } = dispatch({
          type: SET_SEARCH_RESULTS,
          searchResults: response.data.sort(sortByWord),
        });
        return searchResults;
      })
      .catch(err => {
        throw err;
      });
  };
}

export function getWordsOfTheDay(limit, after) {
  return dispatch => {
    const queryParamAfter = after || Date.now() - 86400000; // 1 day in milliseconds
    const queryParamLimit = limit || 1;
    const path = `/words-of-the-day?&limit=${queryParamLimit}&after=${queryParamAfter}`;
    return xhr({ path })
      .then(wordsOfTheDay => {
        dispatch({ type: SET_WORDS_OF_THE_DAY, wordsOfTheDay });
        return wordsOfTheDay.data;
      })
      .catch(err => {
        throw err;
      });
  };
}

export function resetSearchResult() {
  return dispatch => {
    const searchResults = [];
    dispatch({ type: CLEAR_SEARCH_RESULTS, searchResults });
    return { searchResults: null };
  };
}



// WEBPACK FOOTER //
// ./src/redux/words.js